(function () {
  var P = window.ZAP_PRODUCT;
  if (!P || !P.id) { return; }
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

  if (!document.getElementById('zap-fbt-css')) {
    var st = document.createElement('style');
    st.id = 'zap-fbt-css';
    st.textContent = [
      '.zap-fbt{border:1px solid rgba(193,148,63,0.30);border-radius:16px;padding:16px;margin:18px 0;background:#fff;}',
      '.zap-fbt__title{font-weight:800;font-size:17px;color:#1a1a1a;margin:0 0 14px;display:flex;align-items:center;gap:8px;}',
      '.zap-fbt__tic{width:22px;height:22px;flex:0 0 auto;background-position:center;background-repeat:no-repeat;background-size:contain;background-image:url("data:image/svg+xml,%3Csvg%20xmlns=\'http://www.w3.org/2000/svg\'%20viewBox=\'0%200%2024%2024\'%20fill=\'none\'%20stroke=\'%23c1943f\'%20stroke-width=\'2\'%20stroke-linecap=\'round\'%20stroke-linejoin=\'round\'%3E%3Ccircle%20cx=\'9\'%20cy=\'21\'%20r=\'1\'/%3E%3Ccircle%20cx=\'20\'%20cy=\'21\'%20r=\'1\'/%3E%3Cpath%20d=\'M1%201h4l2.7%2013.4a2%202%200%200%200%202%201.6h9.7a2%202%200%200%200%202-1.6L23%206H6\'/%3E%3C/svg%3E");}',
      '.zap-fbt__list{display:flex;flex-direction:column;gap:10px;}',
      '.zap-fbt__item{display:flex;align-items:center;gap:12px;cursor:pointer;}',
      '.zap-fbt__cb{width:18px;height:18px;accent-color:#c1943f;flex:0 0 auto;}',
      '.zap-fbt__img{width:56px;height:56px;border-radius:10px;object-fit:cover;background:#f4f4f4;flex:0 0 auto;}',
      '.zap-fbt__info{flex:1 1 auto;min-width:0;}',
      '.zap-fbt__name{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:13.5px;color:#1a1a1a;line-height:1.3;}',
      '.zap-fbt__price{font-size:13.5px;font-weight:700;color:#c1943f;margin-top:2px;}',
      '.zap-fbt__foot{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:16px;flex-wrap:wrap;}',
      '.zap-fbt__total{font-size:15px;color:#1a1a1a;font-weight:700;}',
      '.zap-fbt__total b{color:#c1943f;}',
      '.zap-fbt__add{background:#c1943f;color:#fff;border:0;border-radius:999px;padding:12px 20px;font-weight:700;font-size:14px;cursor:pointer;flex:1 1 auto;min-width:160px;}',
      '.zap-fbt__add[disabled]{opacity:.55;cursor:default;}'
    ].join('');
    document.head.appendChild(st);
  }

  function money(cents) {
    var v = (parseInt(cents, 10) || 0) / 100;
    try { return '₹' + v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    catch (e) { return '₹' + v.toFixed(2); }
  }
  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = (s == null ? '' : s); return d.innerHTML; }
  function nl2br(s) { return escapeHtml(s).replace(/\n/g, '<br>'); }
  function firstAvailableVariant(p) {
    if (!p.variants || !p.variants.length) { return null; }
    for (var i = 0; i < p.variants.length; i++) { if (p.variants[i].available) { return p.variants[i]; } }
    return p.variants[0];
  }
  function imgOf(p) {
    if (p.featured_image) { return p.featured_image; }
    if (p.images && p.images.length) { return p.images[0]; }
    if (p.media && p.media.length && p.media[0].preview_image) { return p.media[0].preview_image.src; }
    return '';
  }

  function fetchRecs(intent) {
    return fetch(ROOT + 'recommendations/products.json?product_id=' + P.id + '&limit=4&intent=' + intent, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) { return (d && d.products) ? d.products : []; })
      .catch(function () { return []; });
  }

  function hideSelleasy() {
    var blocks = document.querySelectorAll('.product-details__block');
    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      if (b.querySelector('.zap-fbt')) { continue; }
      var t = (b.textContent || '').replace(/\s+/g, ' ');
      if (/Frequently Bought Together/i.test(t)) { b.style.display = 'none'; }
    }
  }

  function render(companions) {
    companions = (companions || []).filter(function (c) { return c && c.id && c.id !== P.variantId; }).slice(0, 3);
    if (!companions.length) { return; }
    if (document.querySelector('.zap-fbt')) { return; }

    var items = [{ id: P.variantId, title: P.title, price: P.price, image: P.image, main: true, available: P.available }];
    companions.forEach(function (c) {
      items.push({ id: c.id, title: c.title, price: c.price, image: c.image, main: false, available: c.available });
    });
    if (items.length < 2) { return; }

    var wrap = document.createElement('div');
    wrap.className = 'zap-fbt';
    var html = '<h3 class="zap-fbt__title"><span class="zap-fbt__tic"></span>Frequently Bought Together</h3><div class="zap-fbt__list">';
    items.forEach(function (it) {
      var checked = (it.available !== false) ? 'checked' : '';
      var dis = it.main ? 'disabled' : '';
      var img = it.image ? ('<img class="zap-fbt__img" src="' + it.image + '" alt="" loading="lazy">') : '<span class="zap-fbt__img"></span>';
      html += '<label class="zap-fbt__item">'
        + '<input type="checkbox" class="zap-fbt__cb" data-id="' + it.id + '" data-price="' + it.price + '" ' + checked + ' ' + dis + '>'
        + img
        + '<span class="zap-fbt__info"><span class="zap-fbt__name">' + (it.main ? 'This item: ' : '') + escapeHtml(it.title) + '</span><span class="zap-fbt__price">' + money(it.price) + '</span></span>'
        + '</label>';
    });
    html += '</div><div class="zap-fbt__foot"><span class="zap-fbt__total">Total: <b class="zap-fbt__totalval"></b></span><button type="button" class="zap-fbt__add">Add selected to cart</button></div>';
    wrap.innerHTML = html;

    var anchor = document.querySelector('.zap-simple') || document.querySelector('.zap-trust') || document.querySelector('.zap-coupons');
    if (anchor) {
      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    } else {
      var infoDiscls = document.querySelectorAll('.product-info details-disclosure');
      if (infoDiscls.length) {
        var last = infoDiscls[infoDiscls.length - 1];
        last.parentNode.insertBefore(wrap, last.nextSibling);
      } else { return; }
    }

    function updateTotal() {
      var cbs = wrap.querySelectorAll('.zap-fbt__cb');
      var tot = 0, n = 0;
      cbs.forEach(function (c) { if (c.checked) { tot += parseInt(c.getAttribute('data-price'), 10) || 0; n++; } });
      wrap.querySelector('.zap-fbt__totalval').textContent = money(tot);
      var btn = wrap.querySelector('.zap-fbt__add');
      btn.textContent = n > 0 ? ('Add ' + n + ' to cart') : 'Add selected to cart';
      btn.disabled = n === 0;
    }
    wrap.addEventListener('change', function (e) { if (e.target.classList && e.target.classList.contains('zap-fbt__cb')) { updateTotal(); } });
    updateTotal();

    wrap.querySelector('.zap-fbt__add').addEventListener('click', function () {
      var cbs = wrap.querySelectorAll('.zap-fbt__cb');
      var payload = [];
      cbs.forEach(function (c) { if (c.checked) { payload.push({ id: parseInt(c.getAttribute('data-id'), 10), quantity: 1 }); } });
      if (!payload.length) { return; }
      var btn = this; btn.disabled = true; var orig = btn.textContent; btn.textContent = 'Adding…';
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: payload }) })
        .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
        .then(function () { window.location.href = ROOT + 'cart'; })
        .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
    });

    hideSelleasy();
  }

  function attempt(recs, tries) {
    if (document.querySelector('.zap-fbt')) { return; }
    if (!document.querySelector('.zap-trust') && tries > 0) {
      setTimeout(function () { attempt(recs, tries - 1); }, 200);
      return;
    }
    render(recs);
  }

  function normalizeRec(p) {
    var v = firstAvailableVariant(p);
    if (!v) { return null; }
    return { id: v.id, title: p.title, price: v.price, image: imgOf(p), available: v.available };
  }

  function moveReviews() {
    var rev = document.getElementById('shopify-section-1753254911a4329391');
    if (!rev) {
      var all = document.querySelectorAll('[id^="shopify-section-"]');
      for (var j = 0; j < all.length; j++) {
        if (all[j].querySelector('.jdgm-widget, .jdgm-rev-widg, #shopify-product-reviews')) { rev = all[j]; break; }
      }
    }
    if (!rev) { return false; }
    if (rev.dataset.zapRev === '1') { return true; }
    var parent = rev.parentNode;
    if (!parent) { return false; }
    var footer = null, kids = parent.children;
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      if (k === rev) { continue; }
      if (/footer/i.test(k.id || '') || k.tagName === 'FOOTER' || k.querySelector('footer')) { footer = k; break; }
    }
    if (footer) { parent.insertBefore(rev, footer); } else { parent.appendChild(rev); }
    rev.dataset.zapRev = '1';
    return true;
  }

  function warrantyStrip() {
    var sec = document.querySelector('.cc-icons-with-text');
    if (!sec) { return false; }
    if (sec.dataset.zapWarr === '1') { return true; }
    var items = sec.querySelectorAll('.slider__item');
    if (!items.length) { return false; }
    var w = window.ZAP_WARRANTY;
    var has = (w !== undefined && w !== null && String(w).trim() !== '' && String(w).trim() !== '0');
    var n = has ? String(w).trim() : '';
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (/warrant/i.test(it.textContent || '')) {
        if (!has) { it.style.display = 'none'; }
        else {
          var title = it.querySelector('.icons-with-text__title');
          if (title) { title.textContent = n + ' Year Warranty'; }
        }
      }
    }
    sec.dataset.zapWarr = '1';
    return true;
  }

  function marqueeStrip() {
    var sec = document.querySelector('.cc-icons-with-text');
    if (!sec) { return false; }
    if (sec.dataset.zapMq === '1') { return true; }
    var items = sec.querySelectorAll('.slider__item');
    if (!items.length) { return false; }
    var order = ['zap-iwt--return', 'zap-iwt--warranty', 'zap-iwt--shipping', 'zap-iwt--discount'];
    var w = window.ZAP_WARRANTY;
    var hasW = (w !== undefined && w !== null && String(w).trim() !== '' && String(w).trim() !== '0');
    var data = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var titleEl = it.querySelector('.icons-with-text__title');
      var label = ((titleEl ? titleEl.textContent : it.textContent) || '').replace(/\s+/g, ' ').trim();
      var t = label.toLowerCase();
      var cls = '';
      if (/return|exchange/.test(t)) { cls = 'zap-iwt--return'; }
      else if (/warrant/.test(t)) { cls = 'zap-iwt--warranty'; }
      else if (/ship|deliver/.test(t)) { cls = 'zap-iwt--shipping'; }
      else if (/discount|offer|save|price/.test(t)) { cls = 'zap-iwt--discount'; }
      else if (i < order.length) { cls = order[i]; }
      else { cls = 'zap-iwt--discount'; }
      if (cls === 'zap-iwt--warranty') {
        if (!hasW) { continue; }
        label = String(w).trim() + ' Year Warranty';
      }
      if (label) { data.push({ cls: cls, label: label }); }
    }
    if (!data.length) { return false; }

    var slider = sec.querySelector('.slider');
    var host = slider ? slider.parentNode : sec.querySelector('.icons-with-text');
    if (!host) { return false; }

    var wrap = document.createElement('div');
    wrap.className = 'zap-mq';
    var track = document.createElement('div');
    track.className = 'zap-mq__track';
    wrap.appendChild(track);

    function addSet() {
      for (var k = 0; k < data.length; k++) {
        var el = document.createElement('div');
        el.className = 'zap-mq__item ' + data[k].cls;
        var sp = document.createElement('span');
        sp.className = 'zap-mq__label';
        sp.textContent = data[k].label;
        el.appendChild(sp);
        track.appendChild(el);
      }
    }

    if (slider) { slider.style.display = 'none'; }
    sec.classList.add('zap-mq-on');
    host.appendChild(wrap);

    addSet();
    var guard = 0;
    while (track.scrollWidth < wrap.clientWidth && guard < 8) { addSet(); guard++; }
    track.innerHTML = track.innerHTML + track.innerHTML;

    sec.dataset.zapMq = '1';
    return true;
  }

  function stickyBar() {
    var panel = document.querySelector('.sticky-atc-panel');
    if (!panel) { return false; }
    if (panel.dataset.zapSticky === '1') { return true; }
    var count = parseInt(P.variantCount, 10) || 0;
    if (count === 1) {
      var card = panel.querySelector('.card--sticky-atc');
      if (!card) { return false; }
      var available = (P.available !== false);
      card.innerHTML = '';
      var wrap = document.createElement('div');
      wrap.className = 'zap-sticky';
      if (!available) {
        wrap.innerHTML = '<button type="button" class="btn zap-add" disabled>Sold out</button>';
        card.appendChild(wrap);
        panel.dataset.zapSticky = '1';
        return true;
      }
      wrap.innerHTML = '<div class="zap-qty"><button type="button" class="zap-qty__btn" data-d="-1" aria-label="Decrease quantity">−</button><input class="zap-qty__in" type="number" value="1" min="1" inputmode="numeric" aria-label="Quantity"><button type="button" class="zap-qty__btn" data-d="1" aria-label="Increase quantity">+</button></div><button type="button" class="btn zap-add">Add to cart</button><button type="button" class="btn zap-buy">Buy now</button>';
      card.appendChild(wrap);
      var input = wrap.querySelector('.zap-qty__in');
      var qbtns = wrap.querySelectorAll('.zap-qty__btn');
      for (var i = 0; i < qbtns.length; i++) {
        (function (bb) {
          bb.addEventListener('click', function () {
            var v = parseInt(input.value, 10) || 1;
            v += parseInt(bb.getAttribute('data-d'), 10);
            if (v < 1) { v = 1; }
            input.value = v;
          });
        })(qbtns[i]);
      }
      function qty() { var v = parseInt(input.value, 10) || 1; return v < 1 ? 1 : v; }
      function addThen(dest, btn) {
        var o = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
        fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: P.variantId, quantity: qty() }] }) })
          .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
          .then(function () { window.location.href = ROOT + dest; })
          .catch(function () { btn.disabled = false; btn.textContent = o; });
      }
      wrap.querySelector('.zap-add').addEventListener('click', function () { addThen('cart', this); });
      wrap.querySelector('.zap-buy').addEventListener('click', function () { addThen('checkout', this); });
    }
    panel.dataset.zapSticky = '1';
    return true;
  }

  function simpleBox() {
    var S = window.ZAP_SIMPLE;
    if (!S) { return false; }
    var what = (S.what || '').trim();
    var where = (S.where || '').trim();
    if (!what && !where) { return false; }
    if (document.querySelector('.zap-simple')) { return true; }
    var anchor = document.querySelector('.zap-trust') || document.querySelector('.zap-coupons');
    if (!anchor) { return false; }
    var wrap = document.createElement('div');
    wrap.className = 'zap-simple';
    var html = '<div class="zap-simple__head"><span class="zap-simple__tag">At a glance</span></div><div class="zap-simple__grid">';
    if (what) { html += '<div class="zap-simple__card zap-simple__card--what"><span class="zap-simple__ic"></span><span class="zap-simple__body"><span class="zap-simple__label">What it does</span><span class="zap-simple__text">' + nl2br(what) + '</span></span></div>'; }
    if (where) { html += '<div class="zap-simple__card zap-simple__card--where"><span class="zap-simple__ic"></span><span class="zap-simple__body"><span class="zap-simple__label">Where to use</span><span class="zap-simple__text">' + nl2br(where) + '</span></span></div>'; }
    html += '</div>';
    wrap.innerHTML = html;
    anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
    return true;
  }

  function galleryDots() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) { return false; }
    if (gallery.dataset.zapDots === '1') { return true; }
    var viewer = gallery.querySelector('#gallery-viewer') || gallery.querySelector('.media-viewer');
    if (!viewer) { return false; }
    var items = viewer.querySelectorAll('.media-viewer__item');
    var n = items.length;
    if (n < 2) { gallery.dataset.zapDots = '1'; return true; }
    var viewerWrap = gallery.querySelector('.media-gallery__viewer') || viewer.parentNode;
    if (!viewerWrap || !viewerWrap.parentNode) { return false; }

    var wrap = document.createElement('div');
    wrap.className = 'zap-dots';
    var track = document.createElement('div');
    track.className = 'zap-dots__track';
    for (var i = 0; i < n; i++) {
      var d = document.createElement('span');
      d.className = 'zap-dot';
      track.appendChild(d);
    }
    wrap.appendChild(track);
    viewerWrap.parentNode.insertBefore(wrap, viewerWrap.nextSibling);

    var dots = track.children;
    var MAX = 5, SLOT = 16;
    function render(active) {
      for (var i = 0; i < n; i++) { dots[i].className = 'zap-dot'; }
      dots[active].classList.add('is-active');
      if (n <= MAX) {
        wrap.style.width = (n * SLOT) + 'px';
        track.style.transform = 'translateX(0)';
        return;
      }
      wrap.style.width = (MAX * SLOT) + 'px';
      var start = active - 2;
      if (start < 0) { start = 0; }
      if (start > n - MAX) { start = n - MAX; }
      track.style.transform = 'translateX(' + (-start * SLOT) + 'px)';
      if (start > 0) {
        dots[start].classList.add('zap-dot--sm');
        if (dots[start + 1]) { dots[start + 1].classList.add('zap-dot--md'); }
      }
      if (start + MAX < n) {
        dots[start + MAX - 1].classList.add('zap-dot--sm');
        if (dots[start + MAX - 2]) { dots[start + MAX - 2].classList.add('zap-dot--md'); }
      }
    }
    var cur = -1;
    function update() {
      var w = viewer.clientWidth;
      if (!w) { return; }
      var a = Math.round(viewer.scrollLeft / w);
      if (a < 0) { a = 0; }
      if (a > n - 1) { a = n - 1; }
      if (a !== cur) { cur = a; render(a); }
    }
    viewer.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    render(0); cur = 0;
    gallery.dataset.zapDots = '1';
    return true;
  }

  function init() {
    hideSelleasy();
    moveReviews();
    warrantyStrip();
    marqueeStrip();
    stickyBar();
    simpleBox();
    galleryDots();
    var manual = Array.isArray(window.ZAP_FBT_ITEMS) ? window.ZAP_FBT_ITEMS.filter(function (c) { return c && c.id && c.id !== P.variantId; }) : [];
    if (manual.length) { attempt(manual, 15); return; }
    fetchRecs('complementary').then(function (recs) {
      var norm = recs.map(normalizeRec).filter(Boolean);
      if (norm.length) { attempt(norm, 15); }
      else { fetchRecs('related').then(function (r2) { attempt(r2.map(normalizeRec).filter(Boolean), 15); }); }
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { hideSelleasy(); moveReviews(); warrantyStrip(); marqueeStrip(); stickyBar(); simpleBox(); galleryDots(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 9000);
  }
})();
